<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'

// Pinia Store
const userStore = useUserStore()

// Computed Property for User Preference
const lineNumbers = computed(() => {
    return userStore.pref('codeMirror_lineNumbers')
})

// Methods
const onClick = () => {
    userStore.setPref({
        name: 'codeMirror_lineNumbers',
        value: !lineNumbers.value
    })
}
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="onClick">
        <span
            :class="{ 'bi-square': !lineNumbers, 'bi-check-square': lineNumbers }"
            class="me-2"
        />
        Line numbers
    </button>
</template>